import { render, staticRenderFns } from "./CampoDescripcion.vue?vue&type=template&id=48b33379"
import script from "./CampoDescripcion.vue?vue&type=script&lang=js"
export * from "./CampoDescripcion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports